<template>
  <div class="growing-months">
    <div class="celebration-title">
      <div class="image">
        <lottie-player v-if="animate" :src="JSON.stringify(require('@/assets/celebration/xmonthspositive.json'))" :autoplay="true" :loop="true"/>
        <img v-else :src="require('@/assets/celebration/xmonthspositive.svg')">
      </div>
      <div class="number-of-months">{{ months }}</div>
      <div class="well-done">
        <span>{{ householdName }},</span>
        <span>איזה יופי!</span>
      </div>
    </div>
    <div class="celebration-subtitle">
      <span>כבר</span>
      <span v-if="months === 2">חודשיים</span>
      <template v-else>
        <span>{{ months }}</span>
        <span>חודשים</span>
      </template>
      <span>שכל תזרים יותר חיובי מהקודם. וואו!</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GrowingMonthsCore',
  props: {
    months: {
      type: Number,
      required: true,
    },
    householdName: {
      type: String,
      required: true,
    },
    animate: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.growing-months {
  .celebration-title {
    position: relative;
    text-align: center;
    font-family: SimplerProBold;
    font-size: 22px;
    line-height: 24px;
    margin-bottom: 20px;

    .image {
      height: 174px;
    }

    .number-of-months {
      font-family: PauzaBold;
      position: absolute;
      width: 100%;
      left: 6px;
      top: 85px;
      text-align: center;
      font-weight: bold;
      color: $riseup_white;
      font-size: 84px;
    }

    .well-done {
      margin-top: 35px;
      font-size: 24px;
      line-height: 20px;
    }
  }

  .celebration-subtitle {
    text-align: center;
    font-size: 18px;
    line-height: 25px;
  }
}

</style>
